import React, {Component} from 'react';
import Alert from '../../../ui/Alert';
import {connect} from 'react-redux';

export class Notifications extends Component {
    render() {
        const {notifications} = this.props;

        if (notifications.get('success').length === 0 && notifications.get('error').length === 0) {
            return null;
        }

        return (
            <div>
                {notifications.get('error').map((message, idx) => <div key={'e-' + idx}><Alert
                    type='danger'>{message}</Alert><br/></div>)}
                {notifications.get('success').map((message, idx) => <div key={'s' - +idx}><Alert
                    type='success'>{message}</Alert><br/></div>)}
            </div>
        );
    }
}

export default connect((state) => ({
    notifications: state.notifications,
}))(Notifications);
